import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMOperationType } from './typings';
import { valToNumber } from './utils';

@Component({
  selector: 'm-operations-pagination',
  template: `
    <div class="m-operations-label-pagination">
      <ng-container *ngIf="mAreaType === 'headerArea'; else elseTemplate">
        <i nz-icon (click)="onPrev()" [class.disabled]="mCurrentPage <= 1">
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="02-业务组件/工具栏导航" transform="translate(-614.000000, -468.000000)">
                <g id="-mockplus-" transform="translate(44.000000, 456.000000)">
                  <g id="编组-6" transform="translate(570.000000, 10.000000)">
                    <g id="icon_suoxiao备份" transform="translate(0.000000, 2.000000)">
                      <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="16" height="16"></rect>
                      <polygon
                        id="路径"
                        fill="#595959"
                        transform="translate(7.704203, 7.742614) rotate(-270.000000) translate(-7.704203, -7.742614) "
                        points="12.6401844 4 13.4084057 4.6401844 7.70420284 11.4852278 2 4.6401844 2.76822128 4 7.70420284 9.92220284"
                      ></polygon>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
        <div class="m-operations-label-pagination-input-box">
          <input
            class="m-operations-label-pagination-input-box-current m-operations-label-pagination-input-box-page"
            [(ngModel)]="mCurrentPage"
            (ngModelChange)="onInputChange($event)"
            (keyup.enter)="onPageChange()"
            (blur)="onPageChange()"
          />
          <span class="m-operations-label-pagination-input-box-total m-operations-label-pagination-input-box-page">/{{ mTotal }}</span>
        </div>
        <i nz-icon (click)="onNext()" [class.disabled]="mCurrentPage >= mTotal">
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="02-业务组件/工具栏导航" transform="translate(-716.000000, -468.000000)">
                <g id="-mockplus-" transform="translate(44.000000, 456.000000)">
                  <g id="编组-6" transform="translate(570.000000, 10.000000)">
                    <g id="icon_suoxiao备份-2" transform="translate(102.000000, 2.000000)">
                      <rect id="矩形" fill="#000000" fill-rule="nonzero" opacity="0" x="0" y="0" width="16" height="16"></rect>
                      <polygon
                        id="路径"
                        fill="#595959"
                        transform="translate(7.704203, 7.742614) rotate(-90.000000) translate(-7.704203, -7.742614) "
                        points="12.6401844 4 13.4084057 4.6401844 7.70420284 11.4852278 2 4.6401844 2.76822128 4 7.70420284 9.92220284"
                      ></polygon>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
      </ng-container>
      <ng-template #elseTemplate>
        <i nz-icon (click)="onPrev()" [class.disabled]="mCurrentPage <= 1">
          <svg
            width="14px"
            height="14px"
            viewBox="0 0 14 14"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="02-02业务组件/底部工具栏设计" transform="translate(-1081.000000, -347.000000)" fill-rule="nonzero">
                <g id="-mockplus-" transform="translate(44.000000, 340.000000)">
                  <g id="-mockplus-" transform="translate(1037.000000, 7.000000)">
                    <g id="icon_suoxiao备份-2" transform="translate(7.000000, 7.000000) scale(1, -1) translate(-7.000000, -7.000000) ">
                      <rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="14" height="14"></rect>
                      <path
                        d="M7,0.875 C10.3827441,0.875 13.125,3.61725591 13.125,7 C13.125,10.3827441 10.3827441,13.125 7,13.125 C3.61725591,13.125 0.875,10.3827441 0.875,7 C0.875,3.61725591 3.61725591,0.875 7,0.875 Z M7,1.7995283 C4.12785879,1.7995283 1.7995283,4.12785879 1.7995283,7 C1.7995283,9.87214121 4.12785879,12.2004717 7,12.2004717 C9.87214121,12.2004717 12.2004717,9.87214121 12.2004717,7 C12.2004717,4.12785879 9.87214121,1.7995283 7,1.7995283 Z M9.10403545,5.6875 L9.72275388,6.30621843 L7.00075194,9.02822038 L4.27875,6.30621843 L4.89746843,5.6875 L7.00075194,7.79086702 L9.10403545,5.6875 Z"
                        id="形状结合"
                        fill="#636363"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
        <div class="m-operations-label-pagination-input-box" [style.width]="'auto'" [style.padding]="0" [style.border]="0">
          <input
            class="m-operations-label-pagination-input-box-current m-operations-label-pagination-input-box-page m-operations-label-pagination-border-bottom"
            [(ngModel)]="mCurrentPage"
            (ngModelChange)="onInputChange($event)"
            (keyup.enter)="onPageChange()"
            (blur)="onPageChange()"
          />
          <span class="m-operations-label-pagination-input-box-total m-operations-label-pagination-input-box-page">/{{ mTotal }}</span>
        </div>
        <i nz-icon (click)="onNext()" [class.disabled]="mCurrentPage >= mTotal">
          <svg
            width="14px"
            height="14px"
            viewBox="0 0 14 14"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="02-02业务组件/底部工具栏设计" transform="translate(-1147.000000, -347.000000)" fill-rule="nonzero">
                <g id="-mockplus-" transform="translate(44.000000, 340.000000)">
                  <g id="编组-2" transform="translate(1055.000000, 7.000000)">
                    <g id="icon_suoxiao备份-2" transform="translate(48.000000, 0.000000)">
                      <rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="14" height="14"></rect>
                      <path
                        d="M7,0.875 C10.3827441,0.875 13.125,3.61725591 13.125,7 C13.125,10.3827441 10.3827441,13.125 7,13.125 C3.61725591,13.125 0.875,10.3827441 0.875,7 C0.875,3.61725591 3.61725591,0.875 7,0.875 Z M7,1.7995283 C4.12785879,1.7995283 1.7995283,4.12785879 1.7995283,7 C1.7995283,9.87214121 4.12785879,12.2004717 7,12.2004717 C9.87214121,12.2004717 12.2004717,9.87214121 12.2004717,7 C12.2004717,4.12785879 9.87214121,1.7995283 7,1.7995283 Z M9.10403545,5.6875 L9.72275388,6.30621843 L7.00075194,9.02822038 L4.27875,6.30621843 L4.89746843,5.6875 L7.00075194,7.79086702 L9.10403545,5.6875 Z"
                        id="形状结合"
                        fill="#636363"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </i>
      </ng-template>
    </div>
  `
})
export class MOperationsPaginationComponent {
  @Input() mTotal = 1;
  @Input() mCurrentPage = 1;
  @Input() mAreaType: IMOperationType = 'headerArea';
  @Output() readonly mCurrentPageChange = new EventEmitter<number>();

  onNext(): void {
    this.mCurrentPage = Math.min(this.mCurrentPage + 1, this.mTotal);
    this.mCurrentPageChange.emit(this.mCurrentPage);
  }

  onPrev(): void {
    this.mCurrentPage = Math.max(this.mCurrentPage - 1, 1);
    this.mCurrentPageChange.emit(this.mCurrentPage);
  }

  onPageChange(): void {
    this.mCurrentPage = Math.min(Math.max(this.mCurrentPage, 1), this.mTotal);
    this.mCurrentPageChange.emit(this.mCurrentPage);
  }

  onInputChange(val: string): void {
    this.mCurrentPage = valToNumber(val, 1);
  }
}
